import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-categories',
  imports: [],
  templateUrl: './categories.component.html',
  styleUrl: './categories.component.css'
})

export class CategoriesComponent {
  @Input() selectedCategory!: string;
  constructor(private router: Router) {

  }
  ngOnInit(): void {
    
    console.log('CategoriesComponent loaded with:', this.selectedCategory);
  }
  showEvent(caseId:string|number) {
    this.router.navigate(['/home/viewcase', caseId]);
  }
  
}
